import { render, staticRenderFns } from "./gradeStudy.vue?vue&type=template&id=a47b9e88&scoped=true&"
import script from "./gradeStudy.vue?vue&type=script&lang=js&"
export * from "./gradeStudy.vue?vue&type=script&lang=js&"
import style0 from "./gradeStudy.vue?vue&type=style&index=0&id=a47b9e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a47b9e88",
  null
  
)

export default component.exports